var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import TappingDialog from "../../components/dialog/tappingdialog.vue";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { objEq, } from "../utilities/aux";
let TappingElement = class TappingElement extends Vue {
    constructor() {
        super(...arguments);
        this.showTappingDialog = false;
        this.tappingImpossible = false;
        this.appliedTapping = [];
    }
    tappingChanged(appliedTappingNodeData) {
        this.appliedTapping = [...appliedTappingNodeData.selection];
        this.showTappingDialog = false;
        return {
            laserSheetCuttingVertexKey: this.tapping.laserSheetCuttingVertexKey,
            candidates: this.tapping.candidates,
            selection: this.appliedTapping,
            nodeIdKey: this.tapping.nodeIdKey,
            svg: this.tapping.svg,
        };
    }
    get elementKey() { return "tapping"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get dialogTapping() {
        return {
            laserSheetCuttingVertexKey: this.tapping.laserSheetCuttingVertexKey,
            candidates: this.tapping.candidates,
            selection: this.appliedTapping,
            svg: this.tapping.svg,
            nodeIdKey: this.tapping.nodeIdKey,
        };
    }
    get appliedString() {
        if (this.appliedTapping.length > 0) {
            const string = this.appliedTapping.reduce((obj, t) => {
                const i = obj.findIndex(o => o.id === t.screwThread.identifier);
                if (i === -1) {
                    obj.push({
                        id: t.screwThread.identifier,
                        number: 1,
                    });
                }
                else {
                    ++obj[i].number;
                }
                return obj;
            }, [])
                .map(o => {
                const screwThread = this.tapping.candidates.flatMap(c => c.matchingScrewThreads)
                    .find(i => i.identifier === o.id);
                if (screwThread === undefined) {
                    throw Error("Error getting name of screw.");
                }
                return o.number.toFixed(0) + "x " + screwThread.name;
            })
                .join(", ");
            return this.i18n.t("chosenThreads") + ": " + string;
        }
        return "";
    }
    created() {
        if (this.tapping.candidates.length === 0) {
            this.tappingImpossible = true;
        }
        this.tappingChanged(this.tapping);
    }
    onTappingChanged() {
        if (!objEq(this.tapping.selection, this.appliedTapping)) {
            this.tappingChanged(this.tapping);
        }
    }
};
__decorate([
    Prop({ required: true })
], TappingElement.prototype, "tapping", void 0);
__decorate([
    Inject()
], TappingElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], TappingElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], TappingElement.prototype, "tappingChanged", null);
__decorate([
    Watch("tapping")
], TappingElement.prototype, "onTappingChanged", null);
TappingElement = __decorate([
    Component({
        components: {
            TappingDialog,
            EditDataElementLabel,
        },
        name: "TappingElement",
    })
], TappingElement);
export default TappingElement;
